export type Bonus = {
  id: string
  title: string
  tagline: string
  intro: string[]
  listLabel: string
  bullets: string[]
  flow?: { label?: string; steps: string[] }
  closing?: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: '30 Ready-to-Use Warm-Ups for Salsa & Bachata',
    tagline: 'Stop improvising the beginning of every class.',
    intro: [
      'Get 30 practical warm-up structures designed specifically for Salsa and Bachata instruction.',
    ],
    listLabel: 'Covers:',
    bullets: [
      'Mobility',
      'Rhythm activation',
      'Coordination',
      'Footwork preparation',
      'Balance',
      'Body control',
      'Partner connection',
      'Turn preparation',
      'Salsa-focused warm-ups',
      'Bachata-focused warm-ups',
      'Beginner groups',
      'Intermediate groups',
    ],
    flow: {
      steps: ['Prepare the body', 'Prepare the rhythm', 'Start with purpose'],
    },
  },
  {
    id: '02',
    title: 'Mixed-Level Class Adaptation Guide',
    tagline: 'One objective. Different levels. One clear teaching strategy.',
    intro: [
      'Learn how to adapt the same teaching objective for beginners, developing dancers and more experienced students.',
    ],
    listLabel: 'Adjust:',
    bullets: [
      'tempo',
      'complexity',
      'repetitions',
      'footwork',
      'partnerwork',
      'combinations',
      'musicality',
      'teacher support',
      'difficulty',
    ],
    flow: { steps: ['Make it easier', 'Standard', 'Level up'] },
    closing: 'Teach mixed groups without building three different classes.',
  },
  {
    id: '03',
    title: 'Social Dance Etiquette & Floorcraft Guide',
    tagline: 'Develop better dancers beyond the classroom',
    intro: [
      'Help students become more confident, respectful and aware in real social dance environments.',
    ],
    listLabel: 'Covers:',
    bullets: [
      'Partner respect',
      'Personal boundaries',
      'Invitations',
      'Changing partners',
      'Comfortable connection',
      'Floor awareness',
      'Space management',
      'Collision prevention',
      'Crowded dance floors',
      'Social dance communication',
    ],
    flow: {
      steps: ['Better awareness', 'Better connection', 'Better social dancers'],
    },
  },
  {
    id: '04',
    title: 'Private Lessons & Workshop Teaching Blueprint',
    tagline: 'Turn your knowledge into structured private lessons and workshops',
    intro: [],
    listLabel: 'Get repeatable frameworks for:',
    bullets: [
      '30-minute private lessons',
      '45-minute private lessons',
      '60-minute private lessons',
      '60-minute workshops',
      '90-minute workshops',
      'Technique intensives',
      'Partnerwork workshops',
      'Musicality sessions',
    ],
    flow: {
      steps: [
        'Identify the objective',
        'Structure the time',
        'Teach with purpose',
      ],
    },
  },
  {
    id: '05',
    title: 'Student Engagement & Retention Guide for Dance Instructors',
    tagline:
      'Help students enjoy the class, recognize progress and stay motivated',
    intro: [],
    listLabel: 'Covers:',
    bullets: [
      'Clear class objectives',
      'Better feedback',
      'Appropriate difficulty',
      'Student motivation',
      'Beginner confidence',
      'Class variety',
      'Progress recognition',
      'Partner rotation',
      'Engagement',
      'Lesson continuity',
    ],
    flow: {
      steps: ['Make progress visible', 'Keep students moving forward'],
    },
  },
]
